import { useLocation } from 'react-router';
import { parseLocaleFromPath } from '#marketing/lib/marketing-locale.js';

/**
 * Current marketing locale from the URL path (`en`, `fr`, or `zh`).
 *
 * @returns {string}
 */
export function useMarketingLocale() {
  const { pathname } = useLocation();
  return parseLocaleFromPath(pathname).locale;
}
